import gsap from 'gsap';

import { app } from '../../utils/store';

class Marquee {
  constructor() {
    this.marquee = {
      el: document.querySelector('.s-marquee .marquee'),
    };

    this.x = {
      delta: 0,
      current: 0,
      velocity: 0,
    };

    this.y = {
      current: 0,
    };

    this.window = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  init() {
    this.add();
  }

  add() {
    gsap.ticker.add(this.inview);
  }

  destroy() {
    gsap.ticker.remove(this.inview);
  }

  inview = () => {
    this.y.current = Math.abs(app.scroll.data.last);

    const b = this.marquee.el.getBoundingClientRect();
    const d = (this.window.height + this.y.current) - (b.top + this.y.current);
    const p = d / ((this.window.height + b.height) / 100);

    if (p > 0 && p < 100) {
      this.render();
    }
  }

  render = () => {
    if (this.x.velocity != null) {
      this.x.delta = this.y.current - this.x.velocity;
    }

    if (this.x.delta < 0) {
      this.x.delta = 0;
    }

    this.x.velocity = this.y.current;

    if (this.x.current > this.marquee.el.getBoundingClientRect().width / 2) {
      this.x.current = 0;
    }

    this.x.current += 1 + (this.x.delta / 3);

    this.marquee.el.style.transform = `translate3d(-${this.x.current}px, 0, 0)`;
  }
}

export default Marquee;
